module.exports = __webpack_public_path__ + "static/media/locations-small-placeholder.60f8f7da.webp";